export default __webpack_public_path__ + "static/back--25-85ff5876583ff145743d6325ee13fc81.webp";